import { statuses } from "@/config";
import useGlobalConfig from "@/store/global";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { LoaderCircle } from "lucide-react";
import { Card } from "antd";
import axios from "axios";
import { Form, Button, Row, Col, Descriptions, Upload } from "antd";
import FormField from "@/components/FormField";
import formFields from "@/config/programs/freetrialFields";
import { useState, useRef } from "react";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { formatDatePickerValue } from "@/utils/formatDate";

const InitiateForm = () => {
  const { themeColor, program } = useGlobalConfig();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [fileList, setFileList] = useState([]);
  const uploadProps = {
    multiple: false,
    beforeUpload: (file) => {
      setFileList([...fileList, file]);
      return false;
    },
    fileList,
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
  };

  const handleSubmit = () => {
    const values = form.getFieldsValue();
    console.log("values: ", values);

    form
      .validateFields()
      .then(async (values) => {
        try {
          setLoading(true);

          const formData = new FormData();
          Object.keys(values).forEach((key) => {
            if (values[key] === null || values[key] === undefined) {
              return;
            }
            
            if (key === "prescription_document") {
              formData.append("file", fileList[0]);
            } else if (key === "prescription_signature_date") {
              formData.append(key, dayjs(new Date()).format("YYYY-MM-DD"));
            } else {
              formData.append(key, values[key]);
            }
          });

          formData.append('program_id', program.id)

          const { data } = await axios.post(
            `free_trial_requests`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            },
          );
          form.resetFields();
          navigate(`/requests/free_trial_requests`);
        } catch (error) {
          console.error(error);
        } finally {
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("Validation failed:", error);
      });
  };

  return (
    <Card className="mb-10 border-t pt-4">
      <div className="mb-6 flex items-center">
        <div className="text-xl font-bold" style={{ color: themeColor }}>
          Free Trial Program - Request Form
        </div>
      </div>
      <Form
        form={form}
        onFinish={handleSubmit}
        layout="vertical"
        className="mt-10 bg-white"
      >
        <div className="text-lg font-semibold">Patient Information</div>
        <Row gutter={[16, 16]} className="mt-4">
          {formFields.patientFields.map((field) => (
            <FormField key={field.name} field={field} />
          ))}
        </Row>
        <div className="text-lg font-semibold">Prescriber Information</div>
        <Row gutter={[16, 16]} className="mt-4">
          {formFields.prescriberFields.map((field) => (
            <FormField key={field.name} field={field} />
          ))}
        </Row>

        <div className="mt-10 text-lg font-semibold">
          Prescription Information
        </div>
        <Row gutter={[16, 16]} className="mt-4">
          {formFields.prescriptionFields.map((field) => (
            <FormField key={field.name} field={field} />
          ))}
          <Col span={12}>
            <Form.Item
              required
              name="prescription_document"
              label="Prescription document"
            >
              <Upload {...uploadProps}>
                <Button>Choose files</Button>
              </Upload>
            </Form.Item>
          </Col>
        </Row>

        <div className="mt-10 text-lg font-semibold">PROGRAM REQUIREMENTS:</div>
        <p className="mt-2 text-sm text-gray-600">
          The Octapharma {program.name.toUpperCase()} Free Trial Program
          is for a maximum of one trial shipment per patient's lifetime. lt is
          ilegal for any person to sellpurchase, or trade; or to offer to sel,
          purchase, or trade or to counterfeit a{" "}
          {program.name.toUpperCase()} Free Trial offer. The{" "}
          {program.name.toUpperCase()} Free Trial Program is validonly
          for product to be dispensed by a pharmacy designated by Fortrea up to
          the limits above. Program eligibility does not require anyfuture
          purchases or orders for {program.name.toUpperCase()} and does
          not reauire any addlitional prescriptionls or refils to be filed.
          Product dispensed pursuanito the terms of the{" "}
          {program.name.toUpperCase()} Free Trial Program shallnot be
          biled to any patient or third-party payer, public (eg, Medicaid,
          Medicare, or anyother similar federal or state healthcare program) or
          private. Ofer good only in the United States and cannot be combined
          with any otherfree trial, coupon, rebate, or similar offer. Octapharma
          reserves the right to rescind, revoke, or amend this program without
          notice. The {program.name.toUpperCase()} Free Trial Program is
          valid for {program.name.toUpperCase()} only-no substitutions
          permitted. The {program.name.toUpperCase()} Free Trial Program
          is good for one fil only andrefils will not be authorized, Void where
          prohibited by law. This is not insurance.
        </p>

        <div className="mt-10 text-lg font-semibold">
          TO BE COMPLETED BY LICENSED PRESCRIBER:
        </div>
        <p className="mt-2 text-sm text-gray-600">
          I have read and agree to the terms and conditions of the{" "}
          {program.name.toUpperCase()} Free Trial Program. In submitting
          this form, I agree that I will not seek payment from any person or
          entity for such product. I attest that I have obtained the parient's
          affirmative authorization to release the above information as may be
          necessary to Octapharma. If patient is younger than 18 years, I attest
          that I have obtained authorization from the patient's legal guardian.
        </p>
        <Row gutter={[16, 16]} className="mt-4">
          {formFields.signatureFields.map((field) => (
            <FormField key={field.name} field={field} />
          ))}
        </Row>
      </Form>
      <Button
        type="primary"
        loading={loading}
        disabled={loading}
        size="large"
        onClick={() => form.submit()}
        className="w-full"
        style={{
          backgroundColor: themeColor,
          borderColor: themeColor,
          color: "white",
        }}
      >
        Submit
      </Button>
    </Card>
  );
};

export default InitiateForm;